export const CONSENT_DECISIONS = Object.freeze(["allow", "deny"]);
export const CONSENT_NONCE_FIELD = "consent_nonce";
export const DECISION_FIELD = "decision";

const SCOPE_LABELS = Object.freeze({
  "mcp:read": "Read your projects, tasks, people and chats",
  "mcp:write": "Make changes as you, where your permissions allow it",
});

export function scopeLabel(scope) {
  return SCOPE_LABELS[scope] ?? scope;
}

export function postConsentDecision(doc, action, fields, decision) {
  if (!CONSENT_DECISIONS.includes(decision)) {
    throw new Error(`consent decision must be one of ${CONSENT_DECISIONS.join(", ")}, got ${JSON.stringify(decision)}`);
  }
  if (!fields || typeof fields[CONSENT_NONCE_FIELD] !== "string" || fields[CONSENT_NONCE_FIELD] === "") {
    throw new Error(`the consent form has no ${CONSENT_NONCE_FIELD}; reload the authorization page`);
  }
  const form = doc.createElement("form");
  form.method = "POST";
  form.action = action;
  const values = { ...fields, [DECISION_FIELD]: decision };
  for (const [name, value] of Object.entries(values)) {
    const input = doc.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = String(value);
    form.appendChild(input);
  }
  doc.body.appendChild(form);
  form.submit();
}
